import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class ScoutingActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsScouting' {
    return 'actionPointsScouting';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.SCOUTING;
  }
}
